export default {
    "ins_1": "Hörmətli müştəri, karta vəsaitin köçürülməsi üçün təlimata əməl edin",
    "ins_1_1": "Şəxsi hesabınızı və doğum tarixinizi daxil edin",
    "ins_2": "Şəxsi hesabı «tərəfdaşlar tərəfindən mikrokreditlərin qaytarılması üsulları» sənədindən və ya M Bulakdakı mütəxəssisinizdən öyrənə bilərsiniz",
    "ins_3": "Daxil etdiyiniz məlumatlar düzgündürsə,«növbəti» düyməsini sıxın",
    "warn": "DİQQƏT!",
    "warn_1": "Əgər ismatrıcda sizin Ad soyadınız qeyd olunmayıbsa, M Bulakdakı mütəxəssisinizlə əlaqə saxlayın",
    "warn_2": "Əgər siz bu ismarıcı səhvən açmısınızsa, buna əhəmiyyət verməyin və heç bir məlumat daxil etməyin",
    "warn_3": "Əgər siz təlimatlara düzgün əməl etmisinizsə və bütün məlumatları düzgün daxil etmisinizsə və buna baxmayaraq telefon nömrənizə şifrə gəlməyibsə M Bulakdakı mütəxəssisinizlə əlaqə saxlayın",
    "warn_4": "Əgər siz hər şeyi düzgün etmisinizsə və təlimatın şərtlərini sona qədər yerinə yetirmisinizsə, daxil etdiyiniz məlumatların təsdiq olunması üçün göstərdiyiniz kartdan 1 manat silinəcək. Məlumatlar təsdiq olunduqdan sonra 10 dəqiqə ərzində 1 manat sizin kartınıza qaytarılacaq.",
    "birthday": "Doğum tarixinizi daxil edin",
    "account": "Şəxsi hesab",
    "digit_range": "2 rəqəmdən 5 rəqəmə qədər",
    "next": "Növbəti",
    "field_required": "Bu sahəni doldurun",
    "operation_failure": "Əməliyyat uğursuz bitmişdir",
    "processing": "Prossesdə",
    "continue": "Davam etmək",
    "enter_code": "Şifrəni daxil edin",
    "page_not_found": "Axtardığınız səhifə tapılmadı",
    "my_docs": "Sənədlər",
    "close": "Yaxın",
    "credit_card": {
        "card_number": "Kart nömrəsi",
        "card_expiration_date": "İstifadə müddəti",
        "check": "Yoxla",
        "submit": "Göndər",
    },
    "repay": {
        "birthday": "Ad günü",
        "account": "Şəxsi hesab",
        "amount": "Ödənişin miqdarı",
        "to_main_site": "Əsas sayta getmək",
        "check": "Yoxlayın",
        "loans": "Kreditlər",
        "payment": "Ödəniş",
        "forgot": "Unutdunuz?",
        "title": "Onlayn kredit ödənişi",
        "modal": {
            "header": "Şəxsi hesabınızı necə tapmaq olar?",
            "p1": "Şəxsi hesabınızı unutmusunuzsa, Şirkətdə qeydiyyatdan keçmiş bir mobil telefondan 8 (903) 76-76-000 nömrəsinə «info» sözü ilə SMS * göndərin, şəxsi hesab nömrənizlə bir SMS alacaqsınız.",
            "p2": "Ayrıca, bir kredit verərkən və geri ödəmə edildikdə, Şirkətdə qeydiyyatdan keçmiş mobil telefon nömrənizə şəxsi hesabı göstərilməklə bir mesaj göndərilir. «L/chet:XX»",
            "p3": "* SMS mesajının dəyəri operatorunuzun tarif planına uyğun olaraq müəyyən edilir."
        }
    },
    "user_docs": {
        "attach": "Əlavə etmək",
        "processing": "Sənəd işlənir",
        "page": "Səhifə {0} / {1}",
        "warning": "DİQQƏT! Sənədləri bağlamazdan əvvəl sənədlərin bütün fotoşəkillərinin hamar, oxunaqlı, parıltılı və qaralmadan olub olmadığını yoxlamaq lazımdır! Sənədlərin surətləri keyfiyyət tələblərinə cavab vermirsə, qəbul edilmir."
    },
    "error_unexpected": "Gözlənilməz səhv baş verdi",
    "doc_view": {
        "null": "Məlumat uyğun deyil"
    },
    "choose_loan": "Выберите договор, по которому вы хотите заплатить",
    "wrong_amount": "Укажите сумму не более чем 150 000 рублей"
};

export const validation = {
    required: "Bu tələb olunan sahədir",
    numeric: "Sahənin dəyəri ədədi olmalıdır",
    positive: "Sahə dəyəri müsbət olmalıdır",
    alpha: "Sahə dəyəri hərfi olmalıdır",
    invalid_email: "Yanlış e-poçt ünvanı formatı",
    card_number: "Yanlış kart nömrəsi formatı",
    invalid_date: "Yanlış tarix",
    card_expired: "Kartın müddəti bitdi",
    file_size: "{0} faylının ölçüsü icazə verilən həddən artıqdır, {1}mb",
    file_type: "Yanlış fayl növü {0}, xahiş edirəm bunlardan birini seçin: {1}",
    client_account: "Fərdi hesabda 2-dən 5-ə qədər rəqəm olmalıdır",
    repay_amount: "Ödəniş məbləği 36 ilə 1.000.000 rubla qədər olmalıdır.",
    char_length: "Sahənin uzunluğu {0} olmalıdır",
    char_length_within: "Sahənin uzunluğu {0} -dən az və {1}-dən böyük olmalıdır",
};